module.exports = __webpack_public_path__ + "img/facility1.b72a0ae5.png";